import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { PolyhedronGeometry } from './PolyhedronGeometry.js';

var TetrahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry) {
  _inheritsLoose(TetrahedronGeometry, _PolyhedronGeometry);

  function TetrahedronGeometry(radius, detail) {
    var _this;

    if (radius === void 0) {
      radius = 1;
    }

    if (detail === void 0) {
      detail = 0;
    }

    var vertices = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1];
    var indices = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1];
    _this = _PolyhedronGeometry.call(this, vertices, indices, radius, detail) || this;
    _this.type = 'TetrahedronGeometry';
    _this.parameters = {
      radius: radius,
      detail: detail
    };
    return _this;
  }

  TetrahedronGeometry.fromJSON = function fromJSON(data) {
    return new TetrahedronGeometry(data.radius, data.detail);
  };

  return TetrahedronGeometry;
}(PolyhedronGeometry);

export { TetrahedronGeometry, TetrahedronGeometry as TetrahedronBufferGeometry };